'use client';

import { useEffect, useRef, useState } from 'react';

// Derives the active step (0-based) from how far the tall section has scrolled
// past the pinned viewport: p = -rect.top / (sectionHeight - viewportHeight).
export default function useHowItWorksScroll(stepCount: number) {
  const ref = useRef<HTMLElement>(null);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    let frame = 0;

    const onScroll = () => {
      if (frame) cancelAnimationFrame(frame);

      frame = requestAnimationFrame(() => {
        const element = ref.current;
        if (!element) return;

        const rect = element.getBoundingClientRect();
        const scrollable = rect.height - window.innerHeight;
        const progress =
          scrollable > 0
            ? Math.max(0, Math.min(0.999, -rect.top / scrollable))
            : 0;
        const active = Math.max(
          0,
          Math.min(stepCount - 1, Math.floor(progress * stepCount))
        );

        setActiveStep(active);
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, [stepCount]);

  return { activeStep, ref };
}
